import { render, staticRenderFns } from "./AddToObjectsGroupModal.vue?vue&type=template&id=0b159954"
import script from "./AddToObjectsGroupModal.vue?vue&type=script&lang=ts"
export * from "./AddToObjectsGroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports